import styled from 'styled-components'

export const DetailHeader = styled.div`
  padding: 16px 20px;
  background: linear-gradient(135deg, #00ade608 0%, #00ade603 100%);
  border-bottom: 1px solid #f0f0f0;
  container-type: inline-size;
`

// Header components (matching ListingDetail pattern)
export const DetailHeaderInfo = styled.div`
  flex: 1;
  margin-right: ${({ theme }) => theme.spacing.medium};
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.small};
`

// Transaction info section (moved from header to body)
export const TransactionInfoSection = styled.div`
  padding: 16px 20px;
  background: linear-gradient(135deg, #00ade608 0%, #00ade603 100%);
  border-bottom: 1px solid #f0f0f0;
  container-type: inline-size;
`

export const TransactionInfoMainContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  margin-bottom: 12px;
`

export const TransactionInfoContent = styled.div`
  flex: 1;
`

export const DetailTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const DetailSubtitle = styled.div`
  font-size: 13px;
  color: #6b6b6b;
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
`

export const DetailHeaderMeta = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`

export const HeaderMetrics = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 16px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f0f0f0;

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 8px;
  }
`
export const HeaderMapContainer = styled.div`
  height: 180px;
  min-height: 180px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  margin-top: 12px;
  position: relative;
  background: #f8f9fa;
  grid-column: 1 / -1;

  .mapboxgl-popup-content {
    padding: 8px 10px;
    font-size: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .mapboxgl-ctrl-attrib {
    display: none;
  }
`
export const HeaderMainContainer = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  margin-bottom: 12px;
`

export const TransactionMapContainer = styled.div`
  height: 140px;
  min-height: 140px;
  width: 300px;
  min-width: 300px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  position: relative;
  background: #f8f9fa;
  flex-shrink: 0;

  @container (max-width: 850px) {
    display: none;
  }

  .mapboxgl-popup-content {
    padding: 8px 10px;
    font-size: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .mapboxgl-ctrl-attrib {
    display: none;
  }
`

// Keep alias for backwards compatibility
export const HeaderMapContainerSide = TransactionMapContainer

export const MetricItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const MetricLabel = styled.span`
  font-size: 11px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const MetricValue = styled.span<{ $highlight?: boolean }>`
  font-size: ${(props) => (props.$highlight ? '16px' : '14px')};
  font-weight: 600;
  color: ${(props) => (props.$highlight ? '#00ade6' : '#1a1a1a')};
`

export const TransactionBadge = styled.span<{ $type?: string }>`
  display: inline-block;
  padding: 4px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  background: ${({ $type }) => {
    switch ($type?.toLowerCase()) {
      case 'achat':
        return 'rgba(0, 173, 230, 0.1)'
      case 'vente':
        return 'rgba(0, 179, 65, 0.1)'
      case 'donation':
        return 'rgba(255, 149, 0, 0.1)'
      case 'succession':
        return 'rgba(142, 142, 147, 0.1)'
      case 'echange':
        return 'rgba(128, 90, 213, 0.1)'
      case 'partage':
        return 'rgba(255, 59, 48, 0.1)'
      default:
        return 'rgba(142, 142, 147, 0.1)'
    }
  }};
  color: ${({ $type }) => {
    switch ($type?.toLowerCase()) {
      case 'achat':
        return '#00ADE6'
      case 'vente':
        return '#00B341'
      case 'donation':
        return '#FF9500'
      case 'succession':
        return '#8E8E93'
      case 'echange':
        return '#805AD5'
      case 'partage':
        return '#FF3B30'
      default:
        return '#8E8E93'
    }
  }};
`

export const PropertyTypeBadge = styled.span`
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  background: rgba(142, 142, 147, 0.1);
  color: #8e8e93;
  margin-left: 8px;
`

export const DetailContent = styled.div`
  padding: 16px 20px;
`

export const WarningBox = styled.div`
  background: rgba(255, 149, 0, 0.1);
  border: 1px solid rgba(255, 149, 0, 0.2);
  border-radius: 6px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #ff9500;
  margin-bottom: 16px;
`

export const DataGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const DataGridOneColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-bottom: 20px;
`

export const DataGroup = styled.div`
  background: white;
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  padding: 16px;
`

export const DataSectionTitle = styled.h3`
  font-size: 13px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 14px;
    height: 14px;
    opacity: 0.7;
  }
`

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f8f8f8;

  &:last-child {
    border-bottom: none;
  }
`

export const DataLabel = styled.span`
  font-size: 13px;
  color: #6b6b6b;
`

export const DataValue = styled.span`
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
  text-align: right;
`

export const PriceValue = styled.span`
  font-size: 15px;
  font-weight: 600;
  color: #00ade6;
  text-align: right;
`

export const DescriptionBox = styled.div`
  background: #f8f9fa;
  border-radius: 6px;
  padding: 12px;
  font-size: 12px;
  line-height: 1.5;
  color: #1a1a1a;
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 300px;
  overflow-y: auto;
`

export const PropertyList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`

export const PropertyItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 6px;
`

export const PropertyNumber = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
`

export const PropertyArea = styled.span`
  font-size: 12px;
  color: #6b6b6b;
`

export const LoadingState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #6b6b6b;
`

export const ErrorState = styled.div`
  text-align: center;
  padding: 60px 20px;
  color: #ff3b30;
`

// Participant styles
export const ParticipantsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const ParticipantGroup = styled.div``

export const ParticipantGroupHeader = styled.div<{ $role: 'buyer' | 'seller' }>`
  padding: 6px 12px;
  background: ${({ $role }) =>
    $role === 'buyer' ? 'rgba(0, 173, 230, 0.08)' : 'rgba(0, 179, 65, 0.08)'};
  border-radius: 6px 6px 0 0;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: ${({ $role }) => ($role === 'buyer' ? '#00ADE6' : '#00B341')};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const ParticipantList = styled.div`
  border: 1px solid #f0f0f0;
  border-top: none;
  border-radius: 0 0 6px 6px;
`

export const ParticipantCard = styled.div`
  padding: 10px 12px;
  border-bottom: 1px solid #f8f8f8;

  &:last-child {
    border-bottom: none;
  }
`

export const ParticipantType = styled.div`
  font-size: 10px;
  color: #888;
  margin-bottom: 2px;
`

export const ParticipantName = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 4px;
`

export const ParticipantDetails = styled.div`
  font-size: 11px;
  color: #6b6b6b;
  line-height: 1.4;

  > div {
    margin-bottom: 2px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`

// Property styles
export const PropertyCard = styled.div`
  background: white;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const PropertyHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f8f8f8;
`

export const MapMarkerBadge = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #2563eb;
  color: white;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
  flex-shrink: 0;
`

export const PropertyBadge = styled.span<{ $type?: string }>`
  display: inline-block;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 600;
  background: ${({ $type }) => {
    switch ($type) {
      case 'PPE':
        return 'rgba(0, 173, 230, 0.1)' // Blue
      case 'B-F':
        return 'rgba(0, 179, 65, 0.1)' // Green
      case 'COP':
        return 'rgba(255, 149, 0, 0.1)' // Orange
      case 'DDP':
        return 'rgba(128, 90, 213, 0.1)' // Purple
      case 'DP':
        return 'rgba(255, 59, 48, 0.1)' // Red
      default:
        return 'rgba(142, 142, 147, 0.1)'
    }
  }};
  color: ${({ $type }) => {
    switch ($type) {
      case 'PPE':
        return '#00ADE6' // Blue
      case 'B-F':
        return '#00B341' // Green
      case 'COP':
        return '#FF9500' // Orange
      case 'DDP':
        return '#805AD5' // Purple
      case 'DP':
        return '#FF3B30' // Red
      default:
        return '#8E8E93'
    }
  }};
`

export const PropertyId = styled.span`
  font-size: 11px;
  color: #888;
`

export const PropertyDetails = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  margin-bottom: 8px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`

export const PropertyInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const PropertyInfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;

  span:first-child {
    color: #888;
  }

  span:last-child {
    color: #1a1a1a;
    font-weight: 500;
  }
`

// Unit styles
export const PropertyUnits = styled.div`
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid #f8f8f8;
`

export const UnitsTitle = styled.div`
  font-size: 11px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
`

export const UnitItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 8px;
  background: #f8f9fa;
  border-radius: 4px;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const UnitType = styled.span`
  font-size: 11px;
  font-weight: 500;
  color: #1a1a1a;
`

export const UnitDetails = styled.span`
  font-size: 11px;
  color: #6b6b6b;
  display: flex;
  gap: 8px;

  > span {
    display: flex;
    align-items: center;
    gap: 2px;
  }
`

// Map container
export const MapContainer = styled.div`
  height: 250px;
  min-height: 250px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid #e5e5e5;
  margin-top: 12px;
  position: relative;
  background: #f8f9fa;

  .mapboxgl-popup-content {
    padding: 8px 10px;
    font-size: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .mapboxgl-ctrl-attrib {
    display: none;
  }
`

// Collapsible section
export const CollapsibleSection = styled.div<{ $isOpen: boolean }>`
  border: 1px solid #f0f0f0;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 12px;
`

export const CollapsibleHeader = styled.button`
  width: 100%;
  padding: 10px 12px;
  background: #fafafa;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #1a1a1a;
  text-transform: uppercase;
  letter-spacing: 0.5px;

  &:hover {
    background: #f5f5f5;
  }

  svg {
    width: 14px;
    height: 14px;
    color: #888;
    transition: transform 0.2s;
  }
`

export const CollapsibleContent = styled.div<{ $isOpen: boolean }>`
  display: ${(props) => (props.$isOpen ? 'block' : 'none')};
  padding: 12px;
  background: white;
`
